const pad =
  (maxLength: number) =>
  (n: number): string =>
    String(n).padStart(maxLength, '0');

const pad2 = pad(2);
const pad3 = pad(3);

/**
 * Локальные дата-время в ISO 8601 со смещением таймзоны.
 * @example toISOStringWithTimeZone(new Date(2026, 3, 3, 15, 30, 45, 7)); // 2026-04-03T15:30:45.007+03:00
 */
export function toISOStringWithTimeZone(date: Date = new Date()): string {
  const offsetMinutes = -date.getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? '+' : '-';
  const abs = Math.abs(offsetMinutes);
  const offH = pad2(Math.floor(abs / 60));
  const offM = pad2(abs % 60);

  const dateString = `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
  const timeString = `${pad2(date.getHours())}:${pad2(date.getMinutes())}:${pad2(date.getSeconds())}`;
  const millisecondsString = pad3(date.getMilliseconds());
  const timezoneString = `${sign}${offH}:${offM}`;

  return `${dateString}T${timeString}.${millisecondsString}${timezoneString}`;
}
